// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XO25","toggle":"styles_toggle__32XFl","preview":"styles_preview__1Z-6B"};